import * as React from "react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { QRCodeSVG } from "qrcode.react";

export default function QrCodeDialog({ open, onClose, title, url, subtitle }) {
  const [copied, setCopied] = React.useState(false);
  const [tooltipOpen, setTooltipOpen] = React.useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(url).then(() => {
      setCopied(true);
      setTooltipOpen(true);
      setTimeout(() => {
        setCopied(false);
        setTooltipOpen(false);
      }, 2000);
    });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen
      PaperProps={{
        sx: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" },
      }}
    >
      <DialogTitle sx={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Typography variant="h5" fontWeight={700}>{title}</Typography>
        <IconButton onClick={onClose} edge="end">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 3,
          flexGrow: 1,
          width: "100%",
        }}
      >
        {subtitle && (
          <Typography variant="body1" color="text.secondary">{subtitle}</Typography>
        )}

        <Box sx={{ p: 3, bgcolor: "#fff", borderRadius: 2, display: "inline-flex" }}>
          <QRCodeSVG
            value={url}
            size={Math.min(window.innerWidth, window.innerHeight) * 0.6}
            level="M"
            fgColor="#111"
          />
        </Box>

        <Stack direction="row" alignItems="center" spacing={1} sx={{ maxWidth: 360 }}>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ wordBreak: "break-all", textAlign: "center", flex: 1 }}
          >
            {url}
          </Typography>
          <Tooltip
            title={copied ? "Link copied!" : "Copy link"}
            open={tooltipOpen}
            onOpen={() => { if (!copied) setTooltipOpen(true); }}
            onClose={() => { if (!copied) setTooltipOpen(false); }}
            arrow
          >
            <IconButton size="small" onClick={handleCopy}>
              <ContentCopyIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
